import { buildCoverSheetConfig } from '../../shared';
import { overrides } from '../landlord';
import { BaseDualConfig, type DualLocaleOverrides } from './base';

/**
 * Builds the coversheet config for a dual representation lease.
 * @param locale Locale code, e.g. CA
 * @returns Coversheet config for specified locale
 */
export function buildDualCoverSheetConfig(locale: string) {
  const localeOverrides: DualLocaleOverrides = overrides[locale] ?? {
    locale,
  };
  return buildCoverSheetConfig(BaseDualConfig, localeOverrides);
}
